<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col lg:w-6/12 w-full">
        <vx-card class="mb-8">
          <div slot="no-body" class="mt-4" style="border">
            <div class="ml-2 mt-4">
              <h4>
                1.&nbsp;&nbsp;&nbsp;<feather-icon class="mt-4 mb-4" icon="ZapIcon" svgClasses="h-6 w-6" />
                Today & Future departures
              </h4>
            </div>
            <vs-tabs>
              <vs-tab label="Direction Client" icon-pack="feather" icon="icon-map">
                <vs-table v-if="transportwaitingfordeparture" ref="table" :data="transportwaitingfordeparture"
                  pagination :max-items="10">
                  <div slot="header" class="
                  flex flex-wrap-reverse
                  items-center
                  flex-grow
                  justify-between
                ">
                    <div class="
                    flex flex-wrap-reverse
                    items-center
                    data-list-btn-container
                  "></div>
                  </div>

                  <template slot="thead"> </template>

                  <template slot-scope="{ data }">
                    <tbody>
                      <vs-tr :key="indexatr1" v-for="(tr, indexatr1) in data">
                        <vs-td>
                          <vs-chip v-if="tr.id" class="ag-grid-cell-chips" color="#AAA">
                            <router-link v-if="tr.id" :to="{
                  path: '/transport/' + tr.id,
                }" class="text-inherit">
                              <span>{{ tr.id }}</span></router-link>

                            &nbsp;
                            <feather-icon icon="TruckIcon" svgClasses="h-5 w-5" />
                            <span v-if="tr.transporter" class="ml-1"><small>{{ tr.transporter.slice(0, 10)
                                }}...</small></span>
                            <span v-else class="ml-1" style="color: #fec"><small>No Transporter</small></span>
                          </vs-chip>
                        </vs-td>
                        <vs-td><small style="vertical-align: top">{{
                  displayDateddMMyyyy(tr.date)
                }}</small></vs-td>
                        <vs-td>
                          <vs-chip v-if="tr.client" class="ag-grid-cell-chips" color="">
                            <img height="20px" v-if="tr.destinationcode == 'BE'" src="@/assets/images/flags/BE.png"
                              alt="BE" />
                            <img height="20px" v-else-if="tr.destinationcode == 'HU'" src="@/assets/images/flags/HU.png"
                              alt="HU" />
                            <img height="20px" v-else-if="tr.destinationcode == 'AT'" src="@/assets/images/flags/AT.png"
                              alt="AT" />
                            <img height="20px" v-else-if="tr.destinationcode == 'NL'" src="@/assets/images/flags/NL.png"
                              alt="NL" />
                            <img height="20px" v-else-if="tr.destinationcode == 'CH'" src="@/assets/images/flags/CH.png"
                              alt="CH" />
                            <img height="20px" v-else-if="tr.destinationcode == 'DE'" src="@/assets/images/flags/DE.png"
                              alt="DE" />
                            <img height="20px" v-else-if="tr.destinationcode == 'ES'" src="@/assets/images/flags/ES.png"
                              alt="ES" />
                            <img height="20px" v-else-if="tr.destinationcode == 'FR'" src="@/assets/images/flags/FR.png"
                              alt="FR" />
                            <img height="20px" v-else-if="tr.destinationcode == 'IT'" src="@/assets/images/flags/IT.png"
                              alt="IT" />
                            <img height="20px" v-else-if="tr.destinationcode == 'LU'" src="@/assets/images/flags/LU.png"
                              alt="LU" />
                            <img height="20px" v-else-if="tr.destinationcode == 'RO'" src="@/assets/images/flags/RO.png"
                              alt="RO" />
                            <img height="20px" v-else-if="tr.destinationcode == 'GB'" src="@/assets/images/flags/UK.png"
                              alt="GB" />
                            <img height="20px" v-else-if="tr.destinationcode == 'PT'" src="@/assets/images/flags/PT.png"
                              alt="PT" />
                            <img height="20px" v-else src="@/assets/images/flags/UE.png" alt="EU" />

                            &nbsp;{{ tr.client }}</vs-chip>
                          <vs-chip v-else class="ag-grid-cell-chips" color="">
                            Client not selected</vs-chip>
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table></vs-tab> <vs-tab label="Direction Teiu" icon-pack="feather" icon="icon-map-pin">
                <vs-table v-if="transportwaitingfordepartureentrant" ref="table"
                  :data="transportwaitingfordepartureentrant" pagination :max-items="10">
                  <div slot="header" class="
                  flex flex-wrap-reverse
                  items-center
                  flex-grow
                  justify-between
                ">
                    <div class="
                    flex flex-wrap-reverse
                    items-center
                    data-list-btn-container
                  "></div>
                  </div>

                  <template slot="thead"> </template>

                  <template slot-scope="{ data }">
                    <tbody>
                      <vs-tr :key="indexatr1" v-for="(tr, indexatr1) in data">
                        <vs-td>
                          <vs-chip v-if="tr.id" class="ag-grid-cell-chips" color="#AAA">
                            <router-link v-if="tr.id" :to="{
                  path: '/transport/' + tr.id,
                }" class="text-inherit">
                              <span>{{ tr.id }}</span></router-link>

                            &nbsp;
                            <feather-icon icon="TruckIcon" svgClasses="h-5 w-5" />
                            <span v-if="tr.transporter" class="ml-1"><small>{{ tr.transporter.slice(0, 10)
                                }}...</small></span>
                            <span v-else class="ml-1" style="color: red"><small>No Transporter</small></span>
                          </vs-chip>
                        </vs-td>
                        <vs-td><small style="vertical-align: top">{{
                  displayDateddMMyyyy(tr.date)
                }}</small></vs-td>
                        <vs-td>
                          <vs-chip v-if="tr.client" class="ag-grid-cell-chips" color="">
                            <img height="20px" v-if="tr.destinationcode == 'BE'" src="@/assets/images/flags/BE.png"
                              alt="BE" />
                            <img height="20px" v-else-if="tr.destinationcode == 'HU'" src="@/assets/images/flags/HU.png"
                              alt="HU" />
                            <img height="20px" v-else-if="tr.destinationcode == 'AT'" src="@/assets/images/flags/AT.png"
                              alt="AT" />
                            <img height="20px" v-else-if="tr.destinationcode == 'NL'" src="@/assets/images/flags/NL.png"
                              alt="NL" />
                            <img height="20px" v-else-if="tr.destinationcode == 'CH'" src="@/assets/images/flags/CH.png"
                              alt="CH" />
                            <img height="20px" v-else-if="tr.destinationcode == 'DE'" src="@/assets/images/flags/DE.png"
                              alt="DE" />
                            <img height="20px" v-else-if="tr.destinationcode == 'ES'" src="@/assets/images/flags/ES.png"
                              alt="ES" />
                            <img height="20px" v-else-if="tr.destinationcode == 'FR'" src="@/assets/images/flags/FR.png"
                              alt="FR" />
                            <img height="20px" v-else-if="tr.destinationcode == 'IT'" src="@/assets/images/flags/IT.png"
                              alt="IT" />
                            <img height="20px" v-else-if="tr.destinationcode == 'LU'" src="@/assets/images/flags/LU.png"
                              alt="LU" />
                            <img height="20px" v-else-if="tr.destinationcode == 'RO'" src="@/assets/images/flags/RO.png"
                              alt="RO" />
                            <img height="20px" v-else-if="tr.destinationcode == 'GB'" src="@/assets/images/flags/UK.png"
                              alt="GB" />
                            <img height="20px" v-else-if="tr.destinationcode == 'PT'" src="@/assets/images/flags/PT.png"
                              alt="PT" />

                      <img height="20px" width="20px" v-else-if="tr.country_code == 'JP'"
                        src="@/assets/images/flags/JP.png" style="
  border-radius: 100%;" alt="JP" />
                      <img height="20px" width="20px" v-else-if="tr.country_code == 'CA'"
                        src="@/assets/images/flags/CA.png" style="
  border-radius: 100%;" alt="CA" />
                            <img height="20px" v-else src="@/assets/images/flags/UE.png" alt="EU" />

                            &nbsp;{{ tr.client }}</vs-chip>
                          <vs-chip v-else class="ag-grid-cell-chips" color="">
                            Provider not selected</vs-chip>
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </vs-tab>
            </vs-tabs>
          </div>
        </vx-card>
      </div>
      <div class="vx-col lg:w-6/12 w-full">
        <vx-card class="mb-8">
          <div slot="no-body" class="mt-4" style="border">
            <div class="ml-2 mt-4">
              <h4>
                3.&nbsp;&nbsp;&nbsp;<feather-icon class="mt-4 mb-4" icon="NavigationIcon" svgClasses="h-6 w-6" />
                On the road
              </h4>
            </div>

            <vs-tabs>
              <vs-tab label="Direction Client" icon-pack="feather" icon="icon-map">
                <vs-table ref="table" :data="transportontheroad" pagination :max-items="10">
                  <div slot="header" class="
                  flex flex-wrap-reverse
                  items-center
                  flex-grow
                  justify-between
                ">
                    <div class="
                    flex flex-wrap-reverse
                    items-center
                    data-list-btn-container
                  "></div>
                  </div>

                  <template slot="thead"> </template>

                  <template slot-scope="{ data }">
                    <tbody>
                      <vs-tr :key="indexatr3" v-for="(tr, indexatr3) in data">
                        <vs-td>
                          <vs-chip v-if="tr.id" class="ag-grid-cell-chips" color="#A9CAB7">
                            <router-link v-if="tr.id" :to="{
                  path: '/transport/' + tr.id,
                }" class="text-inherit">
                              <span>{{ tr.id }}</span></router-link>

                            &nbsp;
                            <feather-icon icon="TruckIcon" svgClasses="h-5 w-5" />
                            <span v-if="tr.transporter" class="ml-1">{{
                  tr.transporter.slice(0, 10)
                }}...</span>
                            <span v-else class="ml-1" style="color: #fec">No transporter</span>
                          </vs-chip>
                        </vs-td>
                        <vs-td><small style="vertical-align: top">Start:{{ displayDateddMMyyyy(tr.date)
                            }}<br />Arr.:
                            {{
                  displayDateddMMyyyy(tr.deadline)
                }}</small></vs-td>
                        <vs-td>
                          <feather-icon icon="PhoneIcon" v-if="tr.call && tr.call.includes('true')" @click="startCall(tr.call)"
                            svgClasses="h-5 w-5 mb-1 stroke-current text-primary cursor-pointer"  />
                          
                          </vs-td>
                        <vs-td>
                          <vs-chip v-if="tr.client" class="ag-grid-cell-chips" color="">
                            <img height="20px" v-if="tr.destinationcode == 'BE'" src="@/assets/images/flags/BE.png"
                              alt="BE" />
                            <img height="20px" v-else-if="tr.destinationcode == 'HU'" src="@/assets/images/flags/HU.png"
                              alt="HU" />
                            <img height="20px" v-else-if="tr.destinationcode == 'AT'" src="@/assets/images/flags/AT.png"
                              alt="AT" />
                            <img height="20px" v-else-if="tr.destinationcode == 'NL'" src="@/assets/images/flags/NL.png"
                              alt="NL" />
                            <img height="20px" v-else-if="tr.destinationcode == 'CH'" src="@/assets/images/flags/CH.png"
                              alt="CH" />
                            <img height="20px" v-else-if="tr.destinationcode == 'DE'" src="@/assets/images/flags/DE.png"
                              alt="DE" />
                            <img height="20px" v-else-if="tr.destinationcode == 'ES'" src="@/assets/images/flags/ES.png"
                              alt="ES" />
                            <img height="20px" v-else-if="tr.destinationcode == 'FR'" src="@/assets/images/flags/FR.png"
                              alt="FR" />
                            <img height="20px" v-else-if="tr.destinationcode == 'IT'" src="@/assets/images/flags/IT.png"
                              alt="IT" />
                            <img height="20px" v-else-if="tr.destinationcode == 'LU'" src="@/assets/images/flags/LU.png"
                              alt="LU" />
                            <img height="20px" v-else-if="tr.destinationcode == 'RO'" src="@/assets/images/flags/RO.png"
                              alt="RO" />
                            <img height="20px" v-else-if="tr.destinationcode == 'GB'" src="@/assets/images/flags/UK.png"
                              alt="GB" />
                            <img height="20px" v-else-if="tr.destinationcode == 'PT'" src="@/assets/images/flags/PT.png"
                              alt="PT" />
                            <img height="20px" v-else src="@/assets/images/flags/UE.png" alt="EU" />

                            &nbsp;{{ tr.client }}</vs-chip>
                          <vs-chip v-else class="ag-grid-cell-chips" color="">
                            Client not selected</vs-chip>
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </vs-tab>
              <vs-tab label="Direction Teiu" icon-pack="feather" icon="icon-map-pin">
                <vs-table ref="table" :data="transportontheroadentrant" pagination :max-items="10">
                  <div slot="header" class="
                  flex flex-wrap-reverse
                  items-center
                  flex-grow
                  justify-between
                ">
                    <div class="
                    flex flex-wrap-reverse
                    items-center
                    data-list-btn-container
                  "></div>
                  </div>

                  <template slot="thead"> </template>

                  <template slot-scope="{ data }">
                    <tbody>
                      <vs-tr :key="indexatr3" v-for="(tr, indexatr3) in data">
                        <vs-td>
                          <vs-chip v-if="tr.id" class="ag-grid-cell-chips" color="#A9CAB7">
                            <router-link v-if="tr.id" :to="{
                  path: '/transport/' + tr.id,
                }" class="text-inherit">
                              <span>{{ tr.id }}</span></router-link>

                            &nbsp;
                            <feather-icon icon="TruckIcon" svgClasses="h-5 w-5" />
                            <span v-if="tr.transporter" class="ml-1">{{
                  tr.transporter.slice(0, 10)
                }}...</span>
                            <span v-else class="ml-1" style="color: red">No transporter</span>
                          </vs-chip>
                        </vs-td>
                        <vs-td><small style="vertical-align: top">Start:{{ displayDateddMMyyyy(tr.date)
                            }}<br />Arrival:{{
                  displayDateddMMyyyy(tr.deadline)
                }}</small></vs-td>
                        <vs-td>
                          <vs-chip v-if="tr.client" class="ag-grid-cell-chips" color="">
                            <img height="20px" v-if="tr.destinationcode == 'BE'" src="@/assets/images/flags/BE.png"
                              alt="BE" />
                            <img height="20px" v-else-if="tr.destinationcode == 'HU'" src="@/assets/images/flags/HU.png"
                              alt="HU" />
                            <img height="20px" v-else-if="tr.destinationcode == 'AT'" src="@/assets/images/flags/AT.png"
                              alt="AT" />
                            <img height="20px" v-else-if="tr.destinationcode == 'NL'" src="@/assets/images/flags/NL.png"
                              alt="NL" />
                            <img height="20px" v-else-if="tr.destinationcode == 'CH'" src="@/assets/images/flags/CH.png"
                              alt="CH" />
                            <img height="20px" v-else-if="tr.destinationcode == 'DE'" src="@/assets/images/flags/DE.png"
                              alt="DE" />
                            <img height="20px" v-else-if="tr.destinationcode == 'ES'" src="@/assets/images/flags/ES.png"
                              alt="ES" />
                            <img height="20px" v-else-if="tr.destinationcode == 'FR'" src="@/assets/images/flags/FR.png"
                              alt="FR" />
                            <img height="20px" v-else-if="tr.destinationcode == 'IT'" src="@/assets/images/flags/IT.png"
                              alt="IT" />
                            <img height="20px" v-else-if="tr.destinationcode == 'LU'" src="@/assets/images/flags/LU.png"
                              alt="LU" />
                            <img height="20px" v-else-if="tr.destinationcode == 'RO'" src="@/assets/images/flags/RO.png"
                              alt="RO" />
                            <img height="20px" v-else-if="tr.destinationcode == 'GB'" src="@/assets/images/flags/UK.png"
                              alt="GB" />
                            <img height="20px" v-else-if="tr.destinationcode == 'PT'" src="@/assets/images/flags/PT.png"
                              alt="PT" />
                            <img height="20px" v-else src="@/assets/images/flags/UE.png" alt="EU" />

                            &nbsp;{{ tr.client }}</vs-chip>
                          <vs-chip v-else class="ag-grid-cell-chips" color="">
                            Client not selected</vs-chip>
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </vs-tab>
            </vs-tabs>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col lg:w-6/12 w-full">
        <vx-card :title="getTitleLeft()">
          <div slot="no-body" class="mt-4 ml-4 mr-4 mb-4">
            <vs-table multiple search v-model="selectedQuotation" @selected="handleSelected" :data="quotation_dashboard"
              :max-items="1000">
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td></vs-td>
                  <vs-td>
                    <vs-chip v-if="((tr.volume - tr.volumetoprepare) / tr.volume) * 100 ==
                  100
                  " class="ag-grid-cell-chips" color="success"><span><small>{{ indextr + 1 }}.</small><b>
                          <router-link :to="{
                  path: '/quotation/' + tr.quotationref,
                }" class="text-inherit">
                            #{{ tr.quotationref }} ⟶</router-link>
                        </b>
                        {{
                  displayDateddMMyyyy(
                    tr.date_delivery_desired.substring(0, 10)
                  )
                }}
                        ⟶
                        <big><b v-if="tr.volumetoprepare >= tr.volume">{{
                  Math.abs(tr.volume - tr.volumetoprepare).toFixed(2)
                }}</b>
                          <b v-else>-{{
                    Math.abs(tr.volume - tr.volumetoprepare).toFixed(
                      2
                    )
                  }} </b>&nbsp;/&nbsp;<b>{{
                    Math.abs(tr.volume).toFixed(2)
                  }}</b>
                          <small>&nbsp;m3</small></big>&nbsp;<small v-if="tr.volumetoprepare >= tr.volume">({{
                  Math.abs(
                    ((tr.volume - tr.volumetoprepare) / tr.volume) *
                    100
                  ).toFixed(0)
                }}%)</small>
                        <small v-else>({{
                    -Math.abs(
                      ((tr.volume - tr.volumetoprepare) / tr.volume) *
                      100
                    ).toFixed(0)
                  }}%)</small></span></vs-chip>
                    <vs-chip v-else class="ag-grid-cell-chips" color="danger"><span><small>{{ indextr + 1 }}.</small><b>
                          <router-link :to="{
                  path: '/quotation/' + tr.quotationref,
                }" class="text-inherit">
                            #{{ tr.quotationref }} ⟶</router-link>
                        </b>
                        {{
                  displayDateddMMyyyy(
                    tr.date_delivery_desired.substring(0, 10)
                  )
                }}
                        ⟶
                        <big><b v-if="tr.volumetoprepare >= tr.volume">{{
                  Math.abs(tr.volume - tr.volumetoprepare).toFixed(2)
                }}</b>
                          <b v-else>-{{
                    Math.abs(tr.volume - tr.volumetoprepare).toFixed(
                      2
                    )
                  }} </b>&nbsp;/&nbsp;<b>{{
                    Math.abs(tr.volume).toFixed(2)
                  }}</b>
                          <small>&nbsp;m3</small></big>&nbsp;<small v-if="tr.volumetoprepare >= tr.volume">({{
                  Math.abs(
                    ((tr.volume - tr.volumetoprepare) / tr.volume) *
                    100
                  ).toFixed(0)
                }}%)</small>
                        <small v-else>({{
                    -Math.abs(
                      ((tr.volume - tr.volumetoprepare) / tr.volume) *
                      100
                    ).toFixed(0)
                  }}%)</small></span></vs-chip>
                    &nbsp;
                    <vs-chip class="ag-grid-cell-chips" color="">
                      <img height="20px" v-if="tr.country_code == 'BE'" src="@/assets/images/flags/BE.png" alt="BE" />
                      <img height="20px" v-else-if="tr.country_code == 'HU'" src="@/assets/images/flags/HU.png"
                        alt="HU" />
                      <img height="20px" v-else-if="tr.country_code == 'AT'" src="@/assets/images/flags/AT.png"
                        alt="AT" />
                      <img height="20px" v-else-if="tr.country_code == 'NL'" src="@/assets/images/flags/NL.png"
                        alt="NL" />
                      <img height="20px" v-else-if="tr.country_code == 'CH'" src="@/assets/images/flags/CH.png"
                        alt="CH" />
                      <img height="20px" v-else-if="tr.country_code == 'DE'" src="@/assets/images/flags/DE.png"
                        alt="DE" />
                      <img height="20px" v-else-if="tr.country_code == 'ES'" src="@/assets/images/flags/ES.png"
                        alt="ES" />
                      <img height="20px" v-else-if="tr.country_code == 'FR'" src="@/assets/images/flags/FR.png"
                        alt="FR" />
                      <img height="20px" v-else-if="tr.country_code == 'IT'" src="@/assets/images/flags/IT.png"
                        alt="IT" />
                      <img height="20px" v-else-if="tr.country_code == 'LU'" src="@/assets/images/flags/LU.png"
                        alt="LU" />
                      <img height="20px" v-else-if="tr.country_code == 'RO'" src="@/assets/images/flags/RO.png"
                        alt="RO" />
                      <img height="20px" v-else-if="tr.country_code == 'GB'" src="@/assets/images/flags/UK.png"
                        alt="GB" />
                      <img height="20px" v-else-if="tr.country_code == 'PT'" src="@/assets/images/flags/PT.png"
                        alt="PT" />
                      <img height="20px" v-else src="@/assets/images/flags/UE.png" alt="EU" />&nbsp;&nbsp;{{ tr.client
                      }}&nbsp;<font v-if="tr.place">({{ tr.place.substring(0, 5) }}...
                        {{ tr.postal_code }})</font>
                      <font v-else>(No delivery address)</font>
                    </vs-chip>
                    <vs-chip v-if="tr.transport && tr.transport.people.length > 0" class="ag-grid-cell-chips"
                      color="#A9CAB7">
                      <router-link v-if="tr.idtransport" :to="{
                  path: '/transport/' + tr.idtransport,
                }" class="text-inherit">
                        <span>{{ tr.transport.id }}</span></router-link>

                      &nbsp;
                      <feather-icon icon="TruckIcon" svgClasses="h-5 w-5" />
                    </vs-chip>
                    <vs-chip v-else-if="tr.transport && tr.transport.people.length == 0
                  " class="ag-grid-cell-chips" color="#c2d1f0">
                      <router-link v-if="tr.idtransport" :to="{
                  path: '/transport/' + tr.idtransport,
                }" class="text-inherit">
                        <span>{{ tr.transport.id }}</span></router-link>&nbsp;
                      <feather-icon icon="TruckIcon" svgClasses="h-5 w-5" />
                    </vs-chip>
                    <vs-chip v-if="tr.mail_top" class="ag-grid-cell-chips" color="#ffc266">
                      <feather-icon icon="MessageSquareIcon" svgClasses="h-5 w-5" /></vs-chip>

                    <br />
                  </vs-td>

                  <vs-td> </vs-td>
                  <vs-td style="width: 10px">
                    <feather-icon icon="ArrowDownIcon" svgClasses="h-5 w-5" @click="openThePopup(tr)" />
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
      <div class="vx-col lg:w-6/12 w-full">
        <vx-card title="Actions">
          <div class="vx-row mb-4">
            <div class="vx-col w-1/3">
              <vs-button v-if="visibilityButtonNew && selectedQuotation.length > 0" type="border" class="mt-4 w-full"
                @click="popup1New = true">New transport<br />(Total:{{
                  sumVolume.toFixed(2)
                }}
                m3)</vs-button>
            </div>
            <div class="vx-col w-1/3">
              <vs-button v-if="visibilityButtonExisting && selectedQuotation.length > 0" color="warning" type="border"
                class="mt-4 w-full" @click="popup2Existing = true">Attach to existing<br />(+{{
                  sumVolume.toFixed(2)
                }}
                m3)</vs-button>
            </div>
            <div class="vx-col w-1/3">
              <vs-button v-if="visibilityButtonDetach && selectedQuotation.length > 0" color="danger" type="border"
                class="mt-4 w-full" @click="confirmDetach">Detach from transport<br />(-{{
                  sumVolume.toFixed(2)
                }}
                m3)</vs-button>
            </div>
            <vs-alert v-if="!visibilityButtonNew &&
                  !visibilityButtonDetach &&
                  !visibilityButtonExisting
                  " color="warning" title="Read me!" active="true" class="mt-4 mb-4">
              Please select PROPERLY 1 or multiple quotations from the table or
              the map.
            </vs-alert>
          </div>
          <vs-popup title="New Transport" :active.sync="popup1New">
            Transport Date:<datepicker class="mb-4" inline v-model="datenew"></datepicker>
            Transporter (facultative)
            <v-select class="mb-4" autocomplete :options="data_option_people_name" v-model="dataIdPeople"
              @input="getBillingAndDeliveryAddressList()" />
            <v-select hidden :options="data_option_billing_address" v-model="billingAddressId" />
            <vs-alert v-if="!billingAddressId && dataIdPeople" color="warning">
              <p>
                The transporter '{{ dataIdPeople.label }}' does NOT have billing
                address<br />

                <vs-button @click="linkWithEditPerson" color="primary" type="filled" class="mb-4">Edit
                  person</vs-button>
              </p>
            </vs-alert>
            <vs-button v-if="(!billingAddressId && !dataIdPeople) ||
                  (billingAddressId && dataIdPeople)
                  " @click="saveNewTransport" color="primary" type="filled" class="mb-4">Save</vs-button>
          </vs-popup>
          <vs-popup title="Add Quotation to Existing Transport" :active.sync="popup2Existing">
            Transport Number
            <v-select class="mb-4" autocomplete :options="existingtransport"
              v-model="dataIdTransportExisting" /><br /><br /><br /><br /><br />
            <vs-button @click="addToExistingTransport" color="primary" type="filled" class="mb-4">Save</vs-button>
          </vs-popup>
        </vx-card>
        <vx-card class="mt-4" title="Destination">
          <template>
            <div>
              <div v-if="!showMap" class="flex flex-col items-center justify-center" style="height: 200px">
                <p class="mb-4 text-center">Click to display the map</p>
                <vs-button icon-pack="feather" icon="icon-map" @click="showMap = true">Afficher la carte</vs-button>
              </div>
              <GmapMap v-else id="map" :center="center" :zoom="zoommap" map-type-id="terrain"
                style="width: 100%; height: 500px">
                <GmapInfoWindow :key="index" v-for="(m, index) in markers" :position="m" :closable="false">
                  <vs-chip v-if="Math.abs(
                  ((markers[index].volume -
                    markers[index].volumetoprepare) /
                    markers[index].volume) *
                  100
                ) == 100
                  " class="ag-grid-cell-chips" color="success"><span><small>{{ index + 1 }}.</small>
                      <b> #{{ markers[index].quotationref }} ⟶ ready </b>&nbsp;({{
                  Math.abs(markers[index].volume.toFixed(0))
                }}
                      m3)</span></vs-chip>
                  <vs-chip v-else class="ag-grid-cell-chips" color="danger"><span><small>{{ index + 1 }}.</small><b> #{{
                  markers[index].quotationref }} ⟶ </b><span v-if="markers[index].volumetoprepare >=
                  markers[index].volume
                  "><big>{{
                  Math.abs(
                    ((markers[index].volume -
                      markers[index].volumetoprepare) /
                      markers[index].volume) *
                    100
                  ).toFixed(0)
                }}%</big>
                        ready</span>
                      <span v-else><big>{{
                    -Math.abs(
                      ((markers[index].volume -
                        markers[index].volumetoprepare) /
                        markers[index].volume) *
                      100
                    ).toFixed(0)
                  }}%</big>
                        ready</span>&nbsp;({{
                    Math.abs(markers[index].volume.toFixed(0))
                  }}
                      m3)</span><br />
                  </vs-chip>

                  <br />
                  <vs-chip v-if="markers[index].transport &&
                  markers[index].transport.people.length > 0
                  " class="ag-grid-cell-chips" color="#A9CAB7">
                    <span>{{ markers[index].transport.id }}</span>&nbsp;
                    <feather-icon icon="TruckIcon" svgClasses="h-5 w-5" />
                  </vs-chip>
                  <vs-chip v-else-if="markers[index].transport &&
                  markers[index].transport.people.length == 0
                  " class="ag-grid-cell-chips" color="#c2d1f0"><span>{{ markers[index].transport.id }}</span>&nbsp;
                    <feather-icon icon="TruckIcon" svgClasses="h-5 w-5" />
                  </vs-chip>
                  <vs-button type="line" icon-pack="feather" icon="icon-check" style="width: 100%; float: center"
                    @click="selectFromMap(index)" v-if="!markers[index].selected" color="primary"
                    class="ag-grid-cell-chips">SELECT</vs-button>
                  <vs-button type="line" icon-pack="feather" icon="icon-hexagoncheck" style="width: 100%; float: center"
                    @click="unselectFromMap(markers[index].quotationref)" v-else color="danger"
                    class="ag-grid-cell-chips">UNSELECT</vs-button>
                </GmapInfoWindow>
              </GmapMap>
            </div>
          </template>
        </vx-card>
        <!--<div slot="no-body" class="mt-4 ml-4 mr-4 mb-4">
            <vs-table :data="transport" class="table-dark-inverted" search>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <vs-chip
                      v-if="tr.transport && tr.client"
                      class="ag-grid-cell-chips"
                      color="#A9CAB7"
                    >
                      <router-link
                        v-if="tr.id"
                        :to="{
                          path: '/transport/' + tr.id,
                        }"
                        class="text-inherit"
                      >
                        <span>{{ tr.id }}</span></router-link
                      >

                      &nbsp;
                      <feather-icon icon="TruckIcon" svgClasses="h-5 w-5" />
                    </vs-chip>
                    <vs-chip v-else class="ag-grid-cell-chips" color="#c2d1f0">
                      <router-link
                        v-if="tr.id"
                        :to="{
                          path: '/transport/' + tr.id,
                        }"
                        class="text-inherit"
                      >
                        <span>{{ tr.id }}</span></router-link
                      >&nbsp;
                      <feather-icon icon="TruckIcon" svgClasses="h-5 w-5" />
                    </vs-chip>

                    <br />
                  </vs-td>

                  <vs-td
                    ><small>Start {{ tr.date }}</small
                    ><small v-if="tr.deadline">→{{ tr.deadline }}</small>
                  </vs-td>
                  <vs-td>
                    <small>{{ tr.transporter }}</small>
                  </vs-td>
                  <vs-td style="width: 10px">
                    <feather-icon
                      icon="ArrowDownIcon"
                      svgClasses="h-5 w-5"
                      @click="openThePopup(tr)"
                    />
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-button
              width="100%"
              color="success"
              type="border"
              class="mt-4 mb-4 w-full"
              >New transport</vs-button
            >
          </div>-->
      </div>
    </div>
    <vs-popup fullscreen :title="OpenedPopupTitle" :active.sync="popupActive">
      <vs-alert v-if="popup_mail_top" color="warning">
        <p>Internal Note: {{ popup_mail_top }}</p>
        <br />
      </vs-alert>
      <vs-table :data="popup_quotation_dashboard_product">
        <template slot="thead">
          <vs-th style="font-size: 100%">Quantity * Product Name</vs-th>
          <vs-th style="font-size: 100%">Current Stock</vs-th>
          <vs-th style="font-size: 100%">Allocated Stock</vs-th>
          <vs-th style="font-size: 100%">Available Stock</vs-th>
          <vs-th style="font-size: 100%">Remaining Stock</vs-th>
          <vs-th style="font-size: 100%">To be prepared</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="indextrr" v-for="(tr, indextrr) in data" style="font-size: 100%">
            <vs-td v-if="tr.category != 'Services'">
              <span>
                {{
                  Math.abs(
                    parseFloat(tr.stock_apres) - parseFloat(tr.stock_avant)
                  ).toFixed(2)
                }}
                {{ tr.uom }} * {{ tr.category }} {{ tr.product }} →
                {{
                  Math.abs(
                    parseFloat(
                      parseFloat(tr.stock_apres) - parseFloat(tr.stock_avant)
                    ) * parseFloat(tr.volume)
                  ).toFixed(2)
                }}
                m3
              </span>
            </vs-td>

            <vs-td v-if="tr.category != 'Services'">
              <span>{{ parseFloat(tr.currentstock).toFixed(2) }} {{ tr.uom }}</span>
            </vs-td>
            <vs-td v-if="tr.category != 'Services'">
              <span>{{
                  Math.abs(
                    parseFloat(tr.stock_avant) - parseFloat(tr.currentstock)
                  ).toFixed(2)
                }}
                {{ tr.uom }}</span>
            </vs-td>

            <vs-td v-if="tr.category != 'Services'">
              <span>{{ parseFloat(tr.stock_avant).toFixed(2) }} {{ tr.uom }}</span>
            </vs-td>
            <vs-td v-if="tr.category != 'Services'">
              <span v-if="parseFloat(tr.stock_apres) >= 0" style="color: green">{{ parseFloat(tr.stock_apres).toFixed(2)
                }} {{ tr.uom }}</span>
              <span v-else>N/A</span>
            </vs-td>

            <vs-td v-if="tr.category != 'Services'">
              <span v-if="parseFloat(tr.stock_apres) < 0" style="color: red">{{
                Math.abs(parseFloat(tr.stock_apres)).toFixed(2) }}
                {{ tr.uom }} ({{
                Math.abs(
                parseFloat(tr.stock_apres) * parseFloat(tr.volume)
                ).toFixed(2)
                }}
                m3)
              </span>
              <span v-else>N/A</span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
const themeColors = ["#28C76F", "#EA5455", "#EA5455", "#FF9F43", "#1E1E1E"];
import axios from "@/axios.js";
import vSelect from "vue-select";
import moduleDataListDashboard from "@/store/dashboard/moduleOperationList.js";

export default {
  components: {
    vSelect,
    Datepicker,
  },
  data: function () {
    return {
      textColor: "red",
    };
  },
  data() {
    return {
      dataIdTransportExisting: null,
      billingAddressId: null,
      data_option_billing_address: [],
      dataOperationCategory: "7",
      dataIdPeople: "",
      data_option_people_name: [],
      datenew: null,
      visibilityButtonNew: false,
      visibilityButtonExisting: false,
      visibilityButtonDetach: false,
      popup1New: false,
      popup2Existing: false,
      sumVolume: 0,
      selectedQuotation: [],
      transportNumber: null,
      OpenedPopupTitle: null,
      popup_mail_top: null,
      popup_quotation_dashboard_product: null,
      popupActive: false,
      itemsPerPage: 25,
      selected: [],
      seconds: 59,
      isMounted: false,
      zoommap: 4,
      center: { lat: 50.0, lng: 12.0 },
      markers: [],
      // Charge la carte Google uniquement sur clic (évite un Map Load facturable par visite).
      showMap: false,
      boundRating: 0,

      purchaseOrdersList: [],
      quotationList: [],
      quotationProductList: [],
      saleList: [],
      evolutionStock: {},
      valuePiquet: [],
      valueBrut: [],
      activePrompt2: false,
      quotationRefClickedPrompt2: null,
      vartotalVolumeReady: 0,

      greenIcon: "http://maps.google.com/mapfiles/kml/paddle/grn-blank.png",
      whiteIcon: "http://maps.google.com/mapfiles/kml/paddle/wht-blank.png",
      blueIcon: "http://maps.google.com/mapfiles/kml/paddle/blu-blank.png",
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    quotation_dashboard() {
      this.totalVolumeReady();
      return this.$store.state.dataListDashboard.quotation_dashboard;
    },
    quotation_dashboard_product() {
      return this.$store.state.dataListDashboard.quotation_dashboard_product;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.quotation_dashboard.length;
    },
    transporttoday() {
      return this.$store.state.dataListDashboard.transporttoday;
    },
    transportentranttoday() {
      return this.$store.state.dataListDashboard.transportentranttoday;
    },
    transportontheroad() {
      return this.$store.state.dataListDashboard.transportontheroad;
    },
    transportontheroadentrant() {
      return this.$store.state.dataListDashboard.transportontheroadentrant;
    },
    transportwaitingfordeparture() {
      return this.$store.state.dataListDashboard.transportwaitingfordeparture;
    },
    transportwaitingfordepartureentrant() {
      return this.$store.state.dataListDashboard.transportwaitingfordepartureentrant;
    },
    existingtransport() {
      return this.$store.state.dataListDashboard.existingtransport;
    },
  },
  methods: {
    startCall(phone) {
    // Supposons que "phone" est une chaîne contenant des informations sur plusieurs clients,
    // séparés par "@", comme "true/+31 6 23748260/Tuinmaak Bv@true/+31 6 23748261/Tuinmaak Bv2"
    let clientsInfo = phone.split('@');

    // Filtrer pour garder seulement les entrées où l'appel est requis (débutant par "true")
    let clientsToCall = clientsInfo.filter(info => info.startsWith('true'));

    // Préparer le texte pour le dialogue en incluant tous les clients nécessitant un appel
    let dialogText = clientsToCall.map(info => {
      let parts = info.split('/');
      let phoneNumber = parts[1];
      let clientName = parts[2];
      return `client ${clientName} (${phoneNumber})`;
    }).join(' and ');

    // Vérifier si au moins un client nécessite un appel
    if (clientsToCall.length > 0) {
      // Afficher le dialogue avec les informations de tous les clients nécessitant un appel
      this.$vs.dialog({
        type: "alert",
        color: "success",
        title: "Call Required",
        text: `Please call ${dialogText} before the truck arrives`,
        acceptText: "Done!",
      });
    } else {
      // Gérer le cas où aucun appel n'est nécessaire ou afficher un message différent
      this.$vs.dialog({
        type: "alert",
        color: "danger",
        title: "No Call Needed",
        text: "No action is required at this time.",
        acceptText: "OK",
      });
    }},
    displayDateddMMyyyy(date) {
      if (moment().format("DDMMM") === moment(date).format("DDMMM")) {
        return 'TODAY';
      } else {
        return moment(date).format("DDMMM");
      }

    },
    linkWithEditPerson() {
      try {
        this.popup1New = false;
        setTimeout(
          () =>
            this.$router.push({
              path: "/person-edit/" + this.dataIdPeople.value,
            }),
          1000
        );
      } catch {
      } finally {
      }
    },
    Refresh() {
      this.selectedQuotation = [];
      this.visibilityButtonNew = false;
      this.visibilityButtonExisting = false;
      this.visibilityButtonDetach = false;
      this.$store
        .dispatch("dataListDashboard/fetchQuotation")
        .then((response) => {
          this.$store.dispatch("dataListDashboard/fetchQuotationProduct");
          this.$store.dispatch("dataListDashboard/fetchVolumeTotal");
        })
        .then((response) => {
          this.$store.dispatch(
            "dataListDashboard/fetchDashboardTransporttoday"
          );
        })
        .then((response) => {
          this.$store.dispatch(
            "dataListDashboard/fetchDashboardTransportEntranttoday"
          );
        })
        .then((response) => {
          this.$store.dispatch(
            "dataListDashboard/fetchDashboardTransportontheroad"
          );
        })
        .then((response) => {
          this.$store.dispatch(
            "dataListDashboard/fetchDashboardTransportontheroadentrant"
          );
        })
        .then((response) => {
          this.$store.dispatch(
            "dataListDashboard/fetchDashboardTransportwaitingfordeparture"
          );
        })
        .then((response) => {
          this.$store.dispatch(
            "dataListDashboard/fetchDashboardTransportwaitingfordepartureentrant"
          );
        })
        .then((response) => {
          this.$store.dispatch(
            "dataListDashboard/fetchDashboardTransportlistforexisting"
          );
        });
    },
    addToExistingTransport() {
      let aviz_serie = moment(this.datenew).add(12, "hours").format("YYYY");
      let idtransport = this.dataIdTransportExisting.value;
      let str = this.selectedQuotation[0].quotationref;
      if (this.selectedQuotation.length > 1) {
        this.selectedQuotation.forEach((e) => {
          str = str + ";" + e.quotationref;
        });
      }
      axios
        .get(
          "/dashboardtransport/addtoexistingtransport/" +
          idtransport +
          "/" +
          str +
          "/" +
          aviz_serie +
          "?who=" + encodeURIComponent(localStorage.getItem("login-username") || '')
        )
        .then((response) => {
          this.popup2Existing = false;
          this.Refresh();
          this.$vs.notify({
            color: "success",
            text: "Transport Updated!",
          });
        });
    },
    saveNewTransport() {
      let obj;
      let date = moment(this.datenew)
        .add(12, "hours")
        .format("YYYY-MM-DD hh:mm:ss+02");
      let aviz_serie = moment(this.datenew).add(12, "hours").format("YYYY");
      let idtransporter = null;
      if (this.dataIdPeople) {
        idtransporter = this.dataIdPeople.value;
      }
      let str = this.selectedQuotation[0].quotationref;
      if (this.selectedQuotation.length > 1) {
        this.selectedQuotation.forEach((e) => {
          str = str + ";" + e.quotationref;
        });
      }
      let billing = "null";
      if (this.billingAddressId) {
        billing = this.billingAddressId.value;
      }
      axios
        .get(
          "/dashboardtransport/createnewtransport/" +
          date +
          "/" +
          idtransporter +
          "/" +
          str +
          "/" +
          aviz_serie +
          "/" +
          billing +
          "?who=" + encodeURIComponent(localStorage.getItem("login-username") || '')
        )

        .then((response) => {
          this.popup1New = false;
          this.Refresh();
          this.$vs.notify({
            color: "success",
            text: "Transport Created!",
          });
        });
    },
    async getBillingAndDeliveryAddressList() {
      {
        this.billingAddressId = null;
        axios
          .get("/person/getaddressbilling/" + this.dataIdPeople.value)
          .then((response) => {
            this.data_option_billing_address = [...response.data];
            this.getSelectedBillingAndDeliveryAddressList();
          });
      }
    },

    async getSelectedBillingAndDeliveryAddressList() {
      {
        axios
          .get(
            "/person/getaddressbilling/" +
            this.dataIdPeople.value +
            "/" +
            this.$route.params.userId
          )
          .then((response) => {
            const ItemIndex = this.data_option_billing_address.findIndex(
              (p) => p.value === response.data[0].value
            );
            this.billingAddressId = this.data_option_billing_address[ItemIndex];
          })
          .then((error) => {
            if (!this.billingAddressId)
              this.billingAddressId = this.data_option_billing_address[0];
          })
          .catch((error) => {
            if (!this.billingAddressId)
              this.billingAddressId = this.data_option_billing_address[0];
          });
      }
    },
    selectFromMap(index) {
      this.selectedQuotation.push(this.quotation_dashboard[index]);
      this.handleSelected(this.quotation_dashboard[index], true);
    },
    unselectFromMap(quoteref) {
      const hello = this.markers.findIndex((p) => p.quotationref === quoteref);
      this.markers[hello].selected = false;
      const ItemIndex = this.selectedQuotation.findIndex(
        (p) => p.quotationref === quoteref
      );
      this.selectedQuotation.splice(ItemIndex, 1);
      this.buttonManager();
      this.calculateVolume(quoteref);
    },
    confirmDetach() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Detachment",
        text: `You are about to detach selected quotation with transport`,
        accept: this.detachRecord,
        acceptText: "Disable",
      });
    },
    detachRecord() {
      let str = this.selectedQuotation[0].quotationref;
      if (this.selectedQuotation.length > 1) {
        this.selectedQuotation.forEach((e) => {
          str = str + ";" + e.quotationref;
        });
      }
      axios
        .get(
          "/dashboardtransport/detachmassquotationsfromexistingtransport/" + str +
          "?who=" + encodeURIComponent(localStorage.getItem("login-username") || '')
        )
        .then((response) => {
          this.Refresh();
          this.showDeleteSuccess();
        });
    },
    showDetachSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Transport Detached",
        text: "The selected quotation was successfully detached from the transport",
      });
    },
    calculateVolume(quotationref) {
      let oldvolume = 0;
      if (this.sumVolume) oldvolume = this.sumVolume;
      this.sumVolume = 0;
      this.selectedQuotation.forEach((e) => {
        this.sumVolume = this.sumVolume + Math.abs(e.volume);
      });
      if (oldvolume >= this.sumVolume) {
        const color = `#EA5455`;
        this.$vs.notify({
          time: 4000,
          title: `Quotation ${quotationref} unselected!`,
          text: `Volume Total: ${Math.abs(this.sumVolume).toFixed(2)} m3`,
          color,
          icon: "icon-up",
          iconPack: "feather",
        });
      } else {
        const color = `#28C76F`;
        this.$vs.notify({
          time: 4000,
          title: `Quotation ${quotationref} selected!`,
          text: `Volume Total: ${Math.abs(this.sumVolume).toFixed(2)} m3`,
          color,
          icon: "icon-up",
          iconPack: "feather",
        });
      }
    },
    buttonManager() {
      this.visibilityButtonDetach = false;
      this.visibilityButtonExisting = false;
      this.visibilityButtonNew = false;

      let iswithtransport = false;
      let iswithouttransport = false;
      this.selectedQuotation.forEach((e) => {
        if (e.idtransport) {
          iswithtransport = true;
        } else {
          iswithouttransport = true;
        }
      });

      if (iswithouttransport && iswithtransport) {
        // stay invisible
      } else if (iswithtransport) {
        this.visibilityButtonDetach = true;
      } else if (iswithouttransport) {
        this.visibilityButtonExisting = true;
        this.visibilityButtonNew = true;
      }
    },

    handleSelected(tr, selectingFromMap = false) {
      if (!selectingFromMap) this.ZoomMap(tr);
      let hello = this.markers.findIndex(
        (p) => p.quotationref === tr.quotationref
      );
      if (this.markers[hello].selected) this.markers[hello].selected = false;
      else this.markers[hello].selected = true;

      this.buttonManager();
      this.calculateVolume(tr.quotationref);
    },
    ZoomMap(t) {
      this.zoommap = 7;
      this.center = new google.maps.LatLng(t.lat, t.lng);
    },
    openThePopup(data) {
      this.OpenedPopupTitle = "Order #" + data.quotationref;
      this.popup_mail_top = data.mail_top;

      this.popup_quotation_dashboard_product = [];
      this.quotation_dashboard_product.forEach((elm) => {
        if (elm.quotationref == data.quotationref) {
          let obj = {
            category: elm.category,
            categoryro: elm.categoryro,
            currentstock: elm.currentstock,
            date_delivery_desired: elm.date_delivery_desired,
            idproduct: elm.idproduct,
            product: elm.product,
            productro: elm.productro,
            quotationref: elm.quotationref,
            stock_apres: elm.stock_apres,
            stock_avant: elm.stock_avant,
            uom: elm.uom,
            volume: elm.volume,
            volumeorder: elm.volumeorder,
            volumetoprepare: elm.volumetoprepare,
          };
          this.popup_quotation_dashboard_product.push(elm);
        }
      });
      this.popupActive = true;
    },
    momentedDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    ZoomOnMap(lat, lng) {
      var mapOptions = {
        zoom: 4,
        center: new google.maps.LatLng(lat, lng),
      };
      var map = new google.maps.Map(document.getElementById("map"), mapOptions);
    },
    iconColor(value) {
      if (!value.idtransport) return this.whiteIcon;
      else if (!value.transport.people.length > 0) return this.blueIcon;
      else return this.greenIcon;
    },
    labelling(value) {
      return value.quotationref + "";
    },
    getMapPosition() {
      this.markers = this.$store.state.dataListDashboard.quotation_dashboard;
    },
    totalVolumeReady() {
      this.vartotalVolumeReady = 0;
      this.$store.state.dataListDashboard.quotation_dashboard_product.forEach(
        (e) => {
          this.vartotalVolumeReady =
            this.vartotalVolumeReady + e.volumetoprepare;
          this.getMapPosition();
          this.$vs.loading.close();
        }
      );
    },
    getTitleLeft() {
      let ready = "calculating...";
      if (this.vartotalVolumeReady) {
        ready = Math.abs(
          Math.round(
            Math.abs(
              parseFloat(
                this.$store.state.dataListDashboard.quotationvolumetotal
                  .volumetotal
              )
            ) - Math.abs(parseFloat(this.vartotalVolumeReady)),
            0
          )
        );
      }
      return (
        "Order in progress ⟶ " +
        ready +
        " m3 / " +
        -Math.round(
          this.$store.state.dataListDashboard.quotationvolumetotal.volumetotal,
          0
        ) +
        " m3 ordered (" +
        Math.abs(
          Math.round(
            (ready /
              this.$store.state.dataListDashboard.quotationvolumetotal
                .volumetotal) *
            100
          ),
          0
        ) +
        "%  ready)"
      );
    },
    async getPeople() {
      axios.get("/people_name/data").then((response) => {
        this.data_option_people_name = [...response.data];
        //this.setDataFromNewPerson();
      });
    },
    getTitleRight() {
      let ready = Math.abs(Math.round(parseFloat(this.vartotalVolumeReady), 0));
      return "To be produced ⟶ " + ready + " m3";
    },
  },
  created() {
    if (localStorage.getItem("login-roles").toLowerCase().includes("invoice")) {
      this.$vs.notify({
        title: "Denied",
        text: "Redirection",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/invoice/invoice-list" });
    }
    try {
      this.$vs.loading();
      if (!moduleDataListDashboard.isRegistered) {
        this.$store.registerModule(
          "dataListDashboard",
          moduleDataListDashboard
        );
        moduleDataListDashboard.isRegistered = true;
      }
      this.$store
        .dispatch("dataListDashboard/fetchQuotation")
        .then((response) => {
          this.$store.dispatch("dataListDashboard/fetchQuotationProduct");
          this.$store.dispatch("dataListDashboard/fetchVolumeTotal");
        })
        .then((response) => {
          this.$store.dispatch(
            "dataListDashboard/fetchDashboardTransporttoday"
          );
        })
        .then((response) => {
          this.$store.dispatch(
            "dataListDashboard/fetchDashboardTransportEntranttoday"
          );
        })
        .then((response) => {
          this.$store.dispatch(
            "dataListDashboard/fetchDashboardTransportontheroad"
          );
        })
        .then((response) => {
          this.$store.dispatch(
            "dataListDashboard/fetchDashboardTransportontheroadentrant"
          );
        })
        .then((response) => {
          this.$store.dispatch(
            "dataListDashboard/fetchDashboardTransportwaitingfordeparture"
          );
        })
        .then((response) => {
          this.$store.dispatch(
            "dataListDashboard/fetchDashboardTransportwaitingfordepartureentrant"
          );
        })
        .then((response) => {
          this.$store.dispatch(
            "dataListDashboard/fetchDashboardTransportlistforexisting"
          );
          this.getPeople();
          this.datenew = moment().format("D MMM yyyy");
          //this.$vs.loading.close();
        });
    } catch (error) {
      alert("LOADING DATA ERROR / CHECK YOUR LOG");
      console.log(error);
    }
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
<style>
.gm-style-iw {
  background-color: v-bind(textColor);
  opacity: 0.9;
}
</style>

<style lang="scss">
button.gm-ui-hover-effect {
  visibility: hidden;
}

#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {

    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */
.ag-grid-cell-chips {
  top: 12px;
  transform: translateY(-50%);
  line-height: 1;
}
</style>

<style lang="scss" scoped>
/*
.ag-grid-cell-chips {
  &.vs-chip-success {
    background: rgba(var(--vs-success), 1);
    color: white !important;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning), 1);
    color: white !important;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger), 1);
    color: white !important;
  }
}*/
</style>
